import { Dispatch } from "react";

import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { RemoteContactViewModel } from "@apiModels/RemoteContactViewModel.csharp";
import { CreateBookingResponseDto } from "@apiModels/CreateBookingResponseDto.csharp";
import { BookingCancellationDeadlineDto } from "@apiModels/BookingCancellationDeadlineDto.csharp";
import { MissingAppointmentsDto } from "@apiModels/MissingAppointments/MissingAppointmentsDto.csharp";
import { RelatedServiceSetup } from "@apiModels/RelatedServiceSetup.csharp";
import { ServicePricingSummary } from "../../../Partials/PricingHighlight/ServicePricingSummary.csharp";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";

export enum FormReducer {
  clear = "clearField",
  update = "update",
}

export enum FormFields {
  "treatment" = "treatment",
  "parentTreatment" = "parentTreatment",
  "service" = "service",
  "location" = "location",
  "doctor" = "doctor",
  "specializationName" = "specializationName",
  "selectedDay" = "selectedDay",
  "selectedMonth" = "selectedMonth",
  "appointment" = "appointment",
  "bookingResponse" = "bookingResponse",
  "bookingSessionId" = "bookingSessionId",
  "currentStep" = "currentStep",
  "remoteContact" = "remoteContact",
  "pricingSummary" = "pricingSummary",
  "cancellationDeadline" = "cancellationDeadline",
  "missingAppointments" = "missingAppointments",
  "wasDifferentTimeZoneModalShown" = "wasDifferentTimeZoneModalShown",
  "relatedServiceSetups" = "relatedServiceSetups",
  "showRelatedServices" = "showRelatedServices",
  "showRelatedServicesMap" = "showRelatedServicesMap",
  "showBaseService" = "showBaseService",
  "breadcrumbs" = "breadcrumbs",
  "hasUserInteracted" = "hasUserInteracted",
}

export type FormStateType = {
  [key: string]: any;
  location: LocationDto;
  treatment: TreatmentsContainerDto | ServiceContainerDto;
  parentTreatment: TreatmentsContainerDto;
  service: ServiceContainerDto;
  doctor: DoctorDto;
  specializationName: string;
  selectedDay: string;
  selectedMonth: string;
  appointment: AppointmentDto;
  missingAppointments: MissingAppointmentsDto;
  bookingResponse: CreateBookingResponseDto;
  currentStep: number;
  remoteContact: RemoteContactViewModel;
  pricingSummary: ServicePricingSummary;
  cancellationDeadline?: BookingCancellationDeadlineDto;
  bookingSessionId: string;
  wasDifferentTimeZoneModalShown: boolean;
  relatedServiceSetups: RelatedServiceSetup[];
  showRelatedServicesMap: Map<number, boolean>;
  showBaseService: boolean;
  breadcrumbs: string[];
  hasUserInteracted?: boolean;
};

export type Action = {
  type: FormReducer;
  field: FormFields;
  payload?: any;
};

export type FormDispatch = Dispatch<Action>;
